import React from 'react';
import { getFlyingStarInterpretation } from './FlyingStarData';

function StarCard({ star, num }) {
    const natureColor = star.nature === 'auspicious' 
        ? 'border-emerald-300 dark:border-emerald-700 bg-emerald-50/50 dark:bg-emerald-900/20' 
        : 'border-red-300 dark:border-red-700 bg-red-50/50 dark:bg-red-900/20';
    const natureBadge = star.nature === 'auspicious'
        ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-800/60 dark:text-emerald-300'
        : 'bg-red-100 text-red-700 dark:bg-red-800/60 dark:text-red-300';
    
    return (
        <div className={`rounded-lg border p-2.5 ${natureColor}`} data-testid={`flying-star-${num}`}>
            <div className="flex items-center gap-2 mb-1.5">
                <span className="font-chinese text-lg font-bold">{star.chinese}</span>
                <span className="text-sm font-semibold">{star.english}</span>
                <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${natureBadge}`}>
                    {star.nature === 'auspicious' ? 'Auspicious' : 'Inauspicious'}
                </span>
            </div>
            <div className="flex items-center gap-2 mb-1.5">
                <span className="text-[11px] px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300">
                    {star.element}
                </span>
                <div className="flex gap-1 flex-wrap">
                    {star.keywords.map((kw, i) => (
                        <span key={i} className="text-[10px] px-1.5 py-0.5 rounded-full bg-white/70 dark:bg-slate-800/70 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
                            {kw}
                        </span>
                    ))}
                </div>
            </div>
            <p className="text-[12px] text-slate-600 dark:text-slate-400 leading-relaxed">{star.meaning}</p>
        </div>
    );
}

export default function FlyingStarDetail({ flyingStars }) {
    if (!flyingStars) return null;
    
    const interp = getFlyingStarInterpretation(flyingStars.first, flyingStars.second);
    if (!interp) return null;
    
    const { star1, star2, overall, overallColor, isDuplicate } = interp;
    
    return (
        <div className="mt-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/30 p-3" data-testid="flying-star-detail">
            <div className="flex items-center gap-2 mb-2">
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">Flying Stars 飛星</span>
                <span className="font-mono text-sm font-bold text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-900/30 px-2 py-0.5 rounded">
                    {flyingStars.display}
                </span>
            </div>
            
            {isDuplicate ? (
                <StarCard star={star1} num={flyingStars.first} />
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <StarCard star={star1} num={flyingStars.first} />
                    <StarCard star={star2} num={flyingStars.second} />
                </div>
            )}
            
            <div className={`mt-2 text-center text-[12px] font-semibold ${overallColor} bg-white/60 dark:bg-slate-800/60 rounded-lg py-1.5 px-2 border border-slate-200 dark:border-slate-700`}>
                {isDuplicate ? `Double ${star1.chinese} ${star1.english}` : `${star1.chinese} + ${star2.chinese}`} — {overall}
            </div>
        </div>
    );
}
